import React, { useEffect, useState } from 'react';

const CacheBuster = ({ position = 'right' }) => {
  const [version, setVersion] = useState('...');

  useEffect(() => {
    // In development, use package.json version
    if (process.env.NODE_ENV === 'development') {
      // Import package.json version for development
      import('../../package.json')
        .then(pkg => setVersion(pkg.version))
        .catch(() => setVersion('dev'));
    } else {
      // In production, fetch from version.json
      fetch('/version.json')
        .then(res => res.json())
        .then(data => setVersion(data.version))
        .catch(() => setVersion('unknown'));
    }
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 5,
        [position]: 17,
        fontSize: '10px',
        color: 'rgba(80,80,80,0.5)',
        
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      v{version}
    </div>
  );
};

export default CacheBuster; 